import { render, staticRenderFns } from "./AddImageFixedRentalSettings.vue?vue&type=template&id=e68b7f98&"
import script from "@/scripts/components/fixedRental/addImageFixedRentalSettings.js?vue&type=script&lang=js&"
export * from "@/scripts/components/fixedRental/addImageFixedRentalSettings.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports